import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Accio } from '../models/accio.model';
import { Bloc } from '../models/bloc.model';
import { Conjunt } from '../models/conjunt.model';
import { FitxaSimulacio } from '../models/fitxa_simulacio.model';
import { Infant } from '../models/infant.model';
import { Questionari } from '../models/questionari.model';
import { ResponsePregunta } from '../models/response_pregunta.model';
import { ResponseQuestionari } from '../models/response_questionari.model';
import { ResponseValoracio } from '../models/response_valoracio.model';
import { Resultat } from '../models/resultat.model';
import { Simulacio } from '../models/simulacio.model';
import { TaulaMestre } from '../models/taula_mestre';
import { Valoracio } from '../models/valoracio.model';
import { RequestsService } from './requests.service';

@Injectable({
  providedIn: 'root'
})
export class RumiService implements OnInit {

  readonly TIPUS_INFANT_NASCITURUS = '0';
  readonly TIPUS_INFANT_NADO = '1';
  readonly TIPUS_UNITAT_EDAT_MESOS = '27';
  readonly MESOS_PER_ANY = 12;

  public simulacio: Simulacio;

  public conjuntsSeleccionats: Array<Conjunt>;
  public pestanyaActiva: string = 'simulacio';
  
  public ambits: Array<TaulaMestre>;
  public unitats_edat_estimada: Array<TaulaMestre>;
  public gravetats: Array<TaulaMestre>;
  public vincles: Array<TaulaMestre>;
  public observacions_fin_observador: Array<TaulaMestre>;
  public observacions_fin_explicacions: Array<TaulaMestre>;

  public valoracions: Array<Valoracio>;

  public accions: Array<Accio>;

  constructor(private requestsService: RequestsService) { }

  ngOnInit() { 
  }

  public getValorsTaulaMestraByNom(pNomTaula: string): Observable<TaulaMestre> {
    const apiUrl = '/taulesMestres/getValorsTaulaMestreByNom/' + pNomTaula;
    return this.requestsService.getGsitGateway(apiUrl);
  }

  public getBlocs(): Observable<Questionari> {
    var apiUrl = '';
    if(this.simulacio.tipusSeleccionat == this.TIPUS_INFANT_NADO || this.simulacio.tipusEdatSeleccionat == 'data_exacta'){
      let date = new Date(this.simulacio.dataSeleccionada);
      let data = date.getDate()+'/'+(date.getMonth() + 1)+'/'+date.getFullYear();
      apiUrl = '/carregarQuestionariPerDataNaixement?ambit='+this.simulacio.ambitSeleccionat+'&dataNaixement='+data;
    }else if(this.simulacio.tipusSeleccionat == this.TIPUS_INFANT_NASCITURUS || this.simulacio.tipusEdatSeleccionat == 'edat_estimada') {
      var edat;
      if(this.simulacio.unitatEdatEstimadaSeleccionada == this.TIPUS_UNITAT_EDAT_MESOS){
        edat = Math.trunc(this.simulacio.edatSeleccionada/this.MESOS_PER_ANY);
      }else{
        edat = this.simulacio.edatSeleccionada;
      }
      apiUrl = '/carregarQuestionariPerEdat?ambit='+this.simulacio.ambitSeleccionat+'&edat='+edat;      
    }
    return this.requestsService.getGsitGateway(apiUrl);
  }

  public getValoracionsFinals(): Observable<Array<Valoracio>> {
    const apiUrl = '/getValoracionsFinals/';
    return this.requestsService.getGsitGateway(apiUrl);
  }

  public getAccions(): Observable<Array<Accio>> {
    const apiUrl = '/accions/getAccions';
    return this.requestsService.getGsitGateway(apiUrl);
  }

  public getResultatAlgorisme(): Observable<Resultat> {
    var apiUrl = '/calculs/executaAlgorisme';
    return this.requestsService.putGsitGateway(apiUrl, this.getResponseQuestionari());
  }

  public getInformeSimulacio() : Observable<Blob>{
    var apiUrl = '/fitxaSimulacio';
    return this.requestsService.putGsitGateway(apiUrl, this.getFitxaSimulacio(), null, 'blob');
  }

  private getResponseQuestionari() : ResponseQuestionari{
    var responseQuestionari: ResponseQuestionari = new ResponseQuestionari();
    
    responseQuestionari.blocs = [];
    responseQuestionari.observacionsProposades = [];

    //Sols s'afegeixen els blocs/conjunts que tenen alguna observacio seleccionada
    this.simulacio.blocs.forEach(bloc=>{
      var nouBloc: Bloc = null;
      if(bloc.conjunts != null && bloc.conjunts.length > 0) {//Si te conjunts
        bloc.conjunts.forEach(conjunt => {
          // if(this.conjuntsSeleccionats.includes(conjunt)){//Si el conjunt, es dels que te alguna observacio seleccionada
            if(nouBloc == null){//Si encara no em clonat el bloc el clonem
              nouBloc = new Bloc();
              nouBloc.id = bloc.id;
              nouBloc.descripcio = bloc.descripcio;
              nouBloc.conjunts = [];
            }
            nouBloc.conjunts.push(conjunt);//Afegim el conjunt al bloc clonat
          // }
          if(conjunt.observacionsProposades != null){//Si te observacions proposades, les afegim a l'array generic de la crida
            conjunt.observacionsProposades.forEach(observacioProposada=>{
              responseQuestionari.observacionsProposades.push(observacioProposada);
            });
          }
        });
        if(nouBloc != null){//si el bloc sa clonat, vol dir que te algun conjunt amb alguna observacio seleccionada i per tant s'ha d'incloure en la crida
          responseQuestionari.blocs.push(nouBloc);
        }
      }
    }); 
    
    responseQuestionari.idAmbit = parseInt(this.simulacio.ambitSeleccionat);

    responseQuestionari.infant = this.getInfant();

    responseQuestionari.nomAmbit = this.getNomAmbit(responseQuestionari.idAmbit);    

    responseQuestionari.respostesValoracions = this.getResponseValoracio();

    console.log(responseQuestionari);

    return responseQuestionari;
  }
  
  private getFitxaSimulacio(): FitxaSimulacio {
    var fitxaSimulacio: FitxaSimulacio = new FitxaSimulacio();

    fitxaSimulacio.conjunts = this.conjuntsSeleccionats;
    fitxaSimulacio.gravetatRisc = this.simulacio.resultat.gravetatRisc;
    
    fitxaSimulacio.idAmbit = parseInt(this.simulacio.ambitSeleccionat);

    fitxaSimulacio.infant = this.getInfant();

    fitxaSimulacio.nomAmbit = this.getNomAmbit(fitxaSimulacio.idAmbit);
    
    fitxaSimulacio.respostesValoracio = this.getResponseValoracio();

    fitxaSimulacio.tipusMaltractament = this.simulacio.resultat.tipusMalPrin;

    fitxaSimulacio.tipusMaltractamentSec = this.simulacio.resultat.tipusMalSec;

    fitxaSimulacio.riscNousEpisodis = this.simulacio.resultat.riscNousEpisodis;
    
    console.log(fitxaSimulacio);

    return fitxaSimulacio;
  }

  private getResponseValoracio(): ResponseValoracio {
    var responseValoracio = new ResponseValoracio();

    responseValoracio.accionsPregunta = this.simulacio.accionsPregunta;
    responseValoracio.collaboraPregunta = this.simulacio.collaboraPregunta;
    responseValoracio.coneixementPregunta = this.simulacio.coneixementPregunta;
    responseValoracio.explicacionsPregunta = this.simulacio.explicacionsPregunta;
    responseValoracio.factorsPregunta = this.simulacio.factorsPregunta;
    responseValoracio.grauPregunta = this.simulacio.grauPregunta;
    responseValoracio.observadorPregunta = this.simulacio.observadorPregunta;
    responseValoracio.vinclePregunta = this.simulacio.vinclePregunta;
    responseValoracio.altresFactorsObservacions = this.simulacio.altresFactorsObservacions;

    return responseValoracio;
  }

  private getInfant(): Infant {
    var infant = new Infant();

    if (this.simulacio.tipusSeleccionat == this.TIPUS_INFANT_NADO || this.simulacio.tipusEdatSeleccionat == 'data_exacta') {
      let date = new Date(this.simulacio.dataSeleccionada);
      let dia = ((date.getDate()<10)?'0':'')+date.getDate();
      let mes = (((date.getMonth() + 1)<10)?'0':'')+(date.getMonth() + 1);   
      let any = date.getFullYear();
      let data = dia+'-'+mes+'-'+any;
      infant.dataNaixement = data;
    } else if (this.simulacio.tipusEdatSeleccionat == 'edat_estimada') {
      this.unitats_edat_estimada.forEach(unitat_edat_estimada=>{
        if(unitat_edat_estimada.id == this.simulacio.unitatEdatEstimadaSeleccionada){
          infant.dataNaixement = this.simulacio.edatSeleccionada + ' ' + unitat_edat_estimada.descripcio;
        }
      });
    }
    infant.edat = this.simulacio.edatSeleccionada;
    infant.sexe = this.simulacio.sexeSeleccionat;
    infant.tipusInfant = parseInt(this.simulacio.tipusSeleccionat);
    
    return infant;
  }

  private getNomAmbit(idAmbit: number): string {
    var nomAmbit = '';
    var ambit = this.ambits.find(ambit=>ambit.id == idAmbit);
    if(ambit != null){
      nomAmbit = ambit.descripcio;
    }
    return nomAmbit;
  }
  
}
